import { inject } from 'aurelia';
import { IHttpClient } from '@aurelia/fetch-client';
import { ApiBase } from '../api-base';
import { LanguageResolver } from '../../infrastructure/language-resolver';

export interface EventAccessEntity {
    id: string;
    sharedWithEmail: string;
    permission: number;
    isAccepted: boolean;
}

@inject(IHttpClient, LanguageResolver)
export class EventAccessApi extends ApiBase {
    constructor(http: IHttpClient, private readonly _languageResolver: LanguageResolver) {
        super(http);
    }

    public async list(eventId: string): Promise<EventAccessEntity[]> {
        const r = await this.get(`api/events/${eventId}/access`);
        return r.content as EventAccessEntity[];
    }

    public async grant(eventId: string, email: string, permission: number = 0): Promise<{ statusCode: number }> {
        const url = `api/events/${eventId}/access?culture=${encodeURIComponent(this._languageResolver.currentLanguage)}`;
        const r = await this.post(url, { email, permission });
        return { statusCode: r.statusCode };
    }

    public async revoke(eventId: string, accessId: string): Promise<void> {
        await this.delete(`api/events/${eventId}/access/${accessId}`);
    }

    public async accept(eventId: string): Promise<void> {
        await this.post(`api/events/${eventId}/access/accept`, {});
    }

    public async removeSelf(eventId: string): Promise<void> {
        await this.delete(`api/events/${eventId}/access/self`);
    }

    public async sendInvitationEmail(eventId: string): Promise<void> {
        const url = `api/events/${eventId}/access/invitation-email?culture=${encodeURIComponent(this._languageResolver.currentLanguage)}`;
        await this.post(url, {});
    }

    public async sendRegistrationEmail(eventId: string): Promise<void> {
        const url = `api/events/${eventId}/access/registration-email?culture=${encodeURIComponent(this._languageResolver.currentLanguage)}`;
        await this.post(url, {});
    }
}
